import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface NotificationItem {
  id: number;
  title: string;
  message: string;
  is_read: boolean;
  created_at: string;
}

export interface NotificationsState {
  notifications: NotificationItem[];
  loading: boolean;
  error: string | null;
}

export const initialState: NotificationsState = {
  notifications: [],
  loading: false,
  error: null,
};

const NotificationsSlice = createSlice({
  name: "Notifications",
  initialState,
  reducers: {
    setNotificationsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setNotifications(state, action: PayloadAction<NotificationItem[]>) {
      state.notifications = action.payload;
      state.loading = false;
      state.error = null;
    },
    setNotificationsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    markNotificationRead(state, action: PayloadAction<number>) {
      const notification = state.notifications.find(n => n.id === action.payload);
      if (notification) {
        notification.is_read = true;
      }
    },
  },
});

export const {
  setNotificationsLoading,
  setNotifications,
  setNotificationsError,
  markNotificationRead,
} = NotificationsSlice.actions;

export default NotificationsSlice.reducer;
